module.exports = __webpack_public_path__ + "img/arrows-middle.056e9ad0.svg";